import { Box, Typography, List, ListItem } from '@mui/material'
import { styled } from '@mui/material/styles'
import { CommonTable } from '../common'

const BoldSpan = styled('span')({
  fontWeight: 'bold',
})

const StyledNestedList = styled(List)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
}))

const StyledSubNestedList = styled(List)(({ theme }) => ({
  paddingLeft: theme.spacing(0),
}))

const columns = [
  { id: 'slNo', label: 'S.No.', width: '80px' },
  { id: 'typeOfData', label: 'Open-Source Software', width: '300px' },
  { id: 'license', label: 'License', width: '300px' },
  { id: 'link', label: 'Link to Access', width: '300px' },
]

// Table data
const tableData = [
  {
    id: 1,
    slNo: '1.',
    typeOfData: 'Angus Mail Provider',
    license: 'GNU General Public License v2.0 w/Classpath exception AND Eclipse Distribution License - v 1.0 AND Eclipse Public License 2.0',
    link: (
      <a href="https://github.com/eclipse-ee4j/angus-mail?tab=License-1-ov-file#readme" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/eclipse-ee4j/angus-mail?tab=License-1-ov-file#readme
      </a>
    ),
  },
  {
    id: 2,
    slNo: '2.',
    typeOfData: 'Jakarta Annotations API',
    license: 'GNU General Public License v2.0 w/Classpath exception AND Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/jakarta.annotation/jakarta.annotation-api/3.0.0" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/jakarta.annotation/jakarta.annotation-api/3.0.0
      </a>
    ),
  },
  {
    id: 3,
    slNo: '3.',
    typeOfData: 'Java Servlet API',
    license: 'GNU General Public License v2.0 w/Classpath exception AND Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/jakarta.servlet/jakarta.servlet-api/6.1.0" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/jakarta.servlet/jakarta.servlet-api/6.1.0
      </a>
    ),
  },
  {
    id: 4,
    slNo: '4.',
    typeOfData: 'Trove for Java',
    license: 'GNU Lesser General Public License 2.1',
    link: (
      <a href="https://central.sonatype.com/artifact/net.sf.trove4j/trove4j/3.0.1" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://central.sonatype.com/artifact/net.sf.trove4j/trove4j/3.0.1
      </a>
    ),
  },
  {
    id: 5,
    slNo: '5.',
    typeOfData: 'jackson-coreutils',
    license: 'Apache License 2.0 AND GNU Lesser General Public License v3.0 or later',
    link: (
      <a href="https://mvnrepository.com/artifact/com.github.fge/jackson-coreutils" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/com.github.fge/jackson-coreutils
      </a>
    ),
  },
  {
    id: 6,
    slNo: '6.',
    typeOfData: 'jakartaee/rest',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://github.com/jakartaee/rest?tab=License-1-ov-file#readme" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/jakartaee/rest?tab=License-1-ov-file#readme
      </a>
    ),
  },
  {
    id: 7,
    slNo: '7.',
    typeOfData: 'json-patch',
    license: 'Apache License 2.0 AND GNU Lesser General Public License v3.0 or later',
    link: (
      <a href="https://github.com/java-json-tools/json-patch?tab=License-1-ov-file#readme" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/java-json-tools/json-patch?tab=License-1-ov-file#readme
      </a>
    ),
  },
  {
    id: 8,
    slNo: '8.',
    typeOfData: 'msg-simple',
    license: 'Apache License 2.0 AND GNU Lesser General Public License v3.0 or later',
    link: (
      <a href="https://github.com/fge/msg-simple?tab=License-1-ov-file#readme" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/fge/msg-simple?tab=License-1-ov-file#readme
      </a>
    ),
  },
  {
    id: 9,
    slNo: '9.',
    typeOfData: 'org.junit.jupiter:junit-jupiter-api',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-api" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-api
      </a>
    ),
  },
  {
    id: 10,
    slNo: '10.',
    typeOfData: 'org.junit.platform:junit-platform-commons',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-api" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-api
      </a>
    ),
  },
  {
    id: 11,
    slNo: '11.',
    typeOfData: 'lightningcss',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file#readme" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file#readme
      </a>
    ),
  },
  {
    id: 12,
    slNo: '12.',
    typeOfData: 'lightningcss-darwin-arm64',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 13,
    slNo: '13.',
    typeOfData: 'lightningcss-darwin-x64',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 14,
    slNo: '14.',
    typeOfData: 'lightningcss-freebsd-x64',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 15,
    slNo: '15.',
    typeOfData: 'lightningcss-linux-arm-gnueabihf',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 16,
    slNo: '16.',
    typeOfData: 'lightningcss-linux-arm64-gnu',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 17,
    slNo: '17.',
    typeOfData: 'lightningcss-linux-arm64-musl',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 18,
    slNo: '18.',
    typeOfData: 'lightningcss-linux-x64-gnu',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 19,
    slNo: '19.',
    typeOfData: 'lightningcss-linux-x64-musl',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 20,
    slNo: '20.',
    typeOfData: 'lightningcss-win32-x64-msvc',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 21,
    slNo: '21.',
    typeOfData: 'parcel-bundler/lightningcss',
    license: 'Mozilla Public License 2.0',
    link: (
      <a href="https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/parcel-bundler/lightningcss?tab=MPL-2.0-1-ov-file
      </a>
    ),
  },
  {
    id: 22,
    slNo: '22.',
    typeOfData: 'AspectJ weaver',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.aspectj/aspectjweaver" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.aspectj/aspectjweaver
      </a>
    ),
  },
  {
    id: 23,
    slNo: '23.',
    typeOfData: 'JUnit',
    license: 'Eclipse Public License 1.0',
    link: (
      <a href="https://github.com/junit-team/junit4" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/junit-team/junit4
      </a>
    ),
  },
  {
    id: 24,
    slNo: '24.',
    typeOfData: 'JUnit 5 (Bill of Materials)',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.junit/junit-bom" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.junit/junit-bom
      </a>
    ),
  },
  {
    id: 25,
    slNo: '25.',
    typeOfData: 'JUnit Jupiter (Aggregator)',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter
      </a>
    ),
  },
  {
    id: 26,
    slNo: '26.',
    typeOfData: 'Jakarta Annotations API',
    license: 'GNU General Public License v2.0 w/Classpath exception OR Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/jakarta.annotation/jakarta.annotation-api" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/jakarta.annotation/jakarta.annotation-api
      </a>
    ),
  },
  {
    id: 27,
    slNo: '27.',
    typeOfData: 'JavaMail API jar',
    license: 'GNU General Public License v2.0 w/Classpath exception AND Eclipse Distribution License - v 1.0 AND Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/jakarta.mail/jakarta.mail-api/2.1.3" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/jakarta.mail/jakarta.mail-api/2.1.3
      </a>
    ),
  },
  {
    id: 28,
    slNo: '28.',
    typeOfData: 'Logback',
    license: 'GNU Lesser General Public License v2.1 only OR Eclipse Public License 1.0',
    link: (
      <a href="https://mvnrepository.com/artifact/ch.qos.logback/logback-classic" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/ch.qos.logback/logback-classic
      </a>
    ),
  },
  {
    id: 29,
    slNo: '29.',
    typeOfData: 'jakarta.persistence-api',
    license: 'GNU General Public License v2.0 w/Classpath exception OR Eclipse Distribution License - v 1.0 OR Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/jakarta.persistence/jakarta.persistence-api" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/jakarta.persistence/jakarta.persistence-api
      </a>
    ),
  },
  {
    id: 30,
    slNo: '30.',
    typeOfData: 'javax.transaction API',
    license: 'GNU General Public License v2.0 w/Classpath exception OR Eclipse Public License 2.0',
    link: (
      <a href="https://github.com/jakartaee/transactions?tab=License-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/jakartaee/transactions?tab=License-1-ov-file
      </a>
    ),
  },
  {
    id: 31,
    slNo: '31.',
    typeOfData: 'org.junit.jupiter:junit-jupiter-api',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-api" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-api
      </a>
    ),
  },
  {
    id: 32,
    slNo: '32.',
    typeOfData: 'org.junit.jupiter:junit-jupiter-engine',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-engine" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-engine
      </a>
    ),
  },
  {
    id: 33,
    slNo: '33.',
    typeOfData: 'org.junit.jupiter:junit-jupiter-params',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-params" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.junit.jupiter/junit-jupiter-params
      </a>
    ),
  },
  {
    id: 34,
    slNo: '34.',
    typeOfData: 'org.junit.platform:junit-platform-commons',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.junit.platform/junit-platform-commons" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.junit.platform/junit-platform-commons
      </a>
    ),
  },
  {
    id: 35,
    slNo: '35.',
    typeOfData: 'org.junit.platform:junit-platform-engine',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://mvnrepository.com/artifact/org.junit.platform/junit-platform-engine" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://mvnrepository.com/artifact/org.junit.platform/junit-platform-engine
      </a>
    ),
  },
  {
    id: 36,
    slNo: '36.',
    typeOfData: 'jakartaee/rest',
    license: 'Eclipse Public License 2.0',
    link: (
      <a href="https://github.com/jakartaee/rest?tab=License-1-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/jakartaee/rest?tab=License-1-ov-file
      </a>
    ),
  },
  {
    id: 37,
    slNo: '37.',
    typeOfData: 'json-patch',
    license: 'Apache License 2.0 AND GNU Lesser General Public License v3.0 or later',
    link: (
      <a href="https://github.com/java-json-tools/json-patch?tab=readme-ov-file" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/java-json-tools/json-patch?tab=readme-ov-file
      </a>
    ),
  },
  {
    id: 38,
    slNo: '38.',
    typeOfData: 'psycopg2',
    license: 'GNU Lesser General Public License v3.0 with Exceptions',
    link: (
      <a href="https://www.psycopg.org/license/" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://www.psycopg.org/license/
      </a>
    ),
  },
  {
    id: 39,
    slNo: '39.',
    typeOfData: 'amqp-client-5.27.1.jar',
    license: 'GPL 2.0',
    link: (
      <a href="https://github.com/rabbitmq/rabbitmq-java-client" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/rabbitmq/rabbitmq-java-client
      </a>
    ),
  },
  {
    id: 40,
    slNo: '40.',
    typeOfData: 'amqp-client-5.25.0.jar',
    license: 'GPL 2.0',
    link: (
      <a href="https://github.com/rabbitmq/rabbitmq-java-client" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/rabbitmq/rabbitmq-java-client
      </a>
    ),
  },
  {
    id: 41,
    slNo: '41.',
    typeOfData: 'amqp-client-5.21.0.jar',
    license: 'GPL 2.0',
    link: (
      <a href="https://github.com/rabbitmq/rabbitmq-java-client" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/rabbitmq/rabbitmq-java-client
      </a>
    ),
  },
  {
    id: 42,
    slNo: '42.',
    typeOfData: 'jasperreports-7.0.6.jar',
    license: 'LGPL v3.0',
    link: (
      <a href="https://github.com/Jaspersoft/jasperreports" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/Jaspersoft/jasperreports
      </a>
    ),
  },
  {
    id: 43,
    slNo: '43.',
    typeOfData: 'jasperreports-fonts-6.21.5.jar',
    license: 'LGPL v3.0',
    link: (
      <a href="https://github.com/Jaspersoft/jasperreports-fonts" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/Jaspersoft/jasperreports-fonts
      </a>
    ),
  },
  {
    id: 44,
    slNo: '44.',
    typeOfData: 'openpdf-2.2.4.jar',
    license: 'LGPL v2.1',
    link: (
      <a href="https://github.com/LibrePDF/OpenPDF" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/LibrePDF/OpenPDF
      </a>
    ),
  },
  {
    id: 45,
    slNo: '45.',
    typeOfData: 'cryptacular-1.2.5.jar',
    license: 'LGPL v3.0',
    link: (
      <a href="https://github.com/vt-middleware/cryptacular" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/vt-middleware/cryptacular
      </a>
    ),
  },
  {
    id: 46,
    slNo: '46.',
    typeOfData: 'smtp-2.0.4.jar',
    license: 'GPL v2.0 with Classpath Exception',
    link: (
      <a href="https://github.com/eclipse-ee4j/angus-mail" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/eclipse-ee4j/angus-mail
      </a>
    ),
  },
  {
    id: 47,
    slNo: '47.',
    typeOfData: 'pop3-2.0.2.jar',
    license: 'GPL v2.0 with Classpath Exception',
    link: (
      <a href="https://github.com/eclipse-ee4j/angus-mail" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/eclipse-ee4j/angus-mail
      </a>
    ),
  },
  {
    id: 48,
    slNo: '48.',
    typeOfData: 'dompurify',
    license: 'MPL 2.0',
    link: (
      <a href="https://github.com/cure53/DOMPurify" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/cure53/DOMPurify
      </a>
    ),
  },
  {
    id: 49,
    slNo: '49.',
    typeOfData: 'jszip',
    license: 'GPL v3.0',
    link: (
      <a href="https://github.com/Stuk/jszip" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/Stuk/jszip
      </a>
    ),
  },
  {
    id: 50,
    slNo: '50.',
    typeOfData: 'paramiko',
    license: 'LGPL v2.1',
    link: (
      <a href="https://github.com/paramiko/paramiko" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/paramiko/paramiko
      </a>
    ),
  },
  {
    id: 51,
    slNo: '51.',
    typeOfData: 'certifi',
    license: 'MPL 2.0',
    link: (
      <a href="https://github.com/certifi/python-certifi" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/certifi/python-certifi
      </a>
    ),
  },
  {
    id: 52,
    slNo: '52.',
    typeOfData: 'orjson',
    license: 'MPL 2.0',
    link: (
      <a href="https://github.com/ijl/orjson" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/ijl/orjson
      </a>
    ),
  },
  {
    id: 53,
    slNo: '53.',
    typeOfData: 'tqdm',
    license: 'MPL 2.0',
    link: (
      <a href="https://github.com/tqdm/tqdm" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
        https://github.com/tqdm/tqdm
      </a>
    ),
  },
]


export default function TermsOfUse() {
  return (
    <Box className="space-y-4">
      <p className="text-sm leading-normal font-family-georgia">
        By clicking on the link, you are accepting these terms and conditions
        (this <strong>&quot;Agreement&quot;</strong>).
      </p>

      <p className="text-sm leading-normal font-family-georgia">
        The words &quot;<BoldSpan>you</BoldSpan>&quot; or &quot;<BoldSpan>your</BoldSpan>&quot; below include (as appropriate to the context) the entity on whose behalf you are entering into this Agreement.
      </p>

      <p className="text-sm leading-normal font-family-georgia">
        If you do not agree to be bound by this Agreement in its entirety, please do not click on the link and you will not be permitted access to the Navigate Withholding Tax (whether the desktop or mobile application versions) (the &quot;<BoldSpan>Solution</BoldSpan>&quot;).
      </p>

      <p className="text-sm leading-normal font-family-georgia">
        The Solution is provided by{' '}
        <BoldSpan>PricewaterhouseCoopers Private Limited</BoldSpan>, an Indian private limited company, incorporated under the laws of India, having registered office at Plot No. Y-14, Block EP, Sector V, Salt Lake Electronics Complex, Bidhannagar, Kolkata - 700091 (&quot;
        <BoldSpan>PwC</BoldSpan>&quot;), pursuant to an engagement letter of rendering professional services entered into by and between PwC and your employer
        (the &quot;
        <BoldSpan>Engagement Letter</BoldSpan>&quot;). For avoidance of doubt, it is clarified that the services provided by PwC under the Engagement Letter are provided solely and exclusively to your employer and not to you.
      </p>

      <p className="text-sm leading-normal font-family-georgia">
        In this Agreement, a <BoldSpan>&quot;PwC Entity&quot;</BoldSpan> is any entity (other than PwC) which carries on business under a name which includes all or part of the PricewaterhouseCoopers name, is a direct or indirect affiliate or subsidiary of a PricewaterhouseCoopers entity or is otherwise within (or associated or connected with an entity within) or is a correspondent firm of the worldwide network of PricewaterhouseCoopers firms, where &quot;entities&quot; or an &quot;entity&quot; includes partnerships, firms, corporations or other entities wherever located each of which entity is a separate legal entity. Unless otherwise indicated either expressly or by the context, the word &quot;partner&quot; is used to describe a member of a PwC Entity in their capacity as such.
      </p>

      <p className="text-sm leading-normal font-family-georgia">
        The access to the Solution is being provided to you for the purpose of GST compliances as per the terms of the Engagement Letter. This Agreement only governs your use of the Solution - it does NOT govern any professional services being provided by PwC to you. Any terms and conditions related to PwC providing such services are the subject of the Engagement Letter. Your access to and use of the Solution, each time you access them, are subject to the following terms and conditions: 
      </p>

      <ListItem alignItems="flex-start" sx={{ display: 'block' }}>
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            '&.MuiTypography-root': {
              fontSize: '14px',
            },
          }}
        >
          1. Eligibility, Registration and Use of the Solution
        </Typography>

        <StyledNestedList>
          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              a. All registrations must contain the required fields indicated on the registration form. You warrant that all information provided or confirmed by you in connection with registration is true, accurate, complete and up-to-date and you agree to make any changes necessary to your user profile on the Solution to ensure that such information is true, accurate, complete and up-to-date at all times.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              b. You will be required to enter your username and password every time you wish to access the Solution. Your username and password are personal to you and nontransferable, and you shall maintain them in strict confidence and will not communicate them to anyone else or allow anyone else to use them. You shall use strong passwords and periodically change them.
            </Typography>

            <StyledSubNestedList>
              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (i) You are responsible for all use of the Solution made using your username and password, regardless of the identity of the person making such use, and PwC, PwC Entities and its or their contractors will not have any responsibility or liability in connection with any unauthorised use of the usernames or passwords or any unauthorized use of the Solution.
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (ii) If you become aware of a breach of security with respect to your password or of any other breach of security, you will immediately notify PwC. Your access to or use of the Solution may be immediately suspended with or without notice by PwC at any time for any reason.
                </Typography>
              </ListItem>
            </StyledSubNestedList>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              c. Except as otherwise expressly permitted under this Agreement, you may not do any of the following, nor may you authorise any third party to do any of the following with respect to the Solution, including without limitation any of its related technology and databases: 
            </Typography>

            <StyledSubNestedList>
              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography variant="body2">
                  (i) access or use any portion except for the agreed purposes (and in particular not to use or access any portion for commercial, marketing or advertising use/purposes); 
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography variant="body2">
                  (ii) modify or create any derivative works:
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography variant="body2">
                  (iii) decompile, disassemble, reverse engineer, or otherwise attempt to derive the related source code; 
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography variant="body2">
                  (iv) Use any robot, spider, search/retrieval application or other manual or automatic device to (a) retrieve, index, &quot;scrape,&quot; &quot;data mine&quot; or otherwise gather content from the Solution (b) reproduce or circumvent the navigational structure or presentation of the Solution, or (c) Harvest or collect information about users of the Solution;
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography variant="body2">
                  (v) redistribute, encumber, sell, rent, lease, use for service bureau purposes, sublicense or otherwise transfer any related rights or interfere with or disrupt the operation of the Solution or the servers; or 
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography variant="body2">
                  (vi) remove or alter any related trademark, logo, copyright or other proprietary notices. 
                </Typography>
              </ListItem>
            </StyledSubNestedList>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              d. You may not reproduce or copy any portion of the Solution other than:
            </Typography>

            <StyledSubNestedList>
              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (i) to access the Solution in accordance with this Agreement: or
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (ii) to reproduce a reasonable number of hard copies of information obtained from the Solution for the use only for the purposes for which such information was provided by the party concerned and subject to any confidentiality obligations.
                </Typography>
              </ListItem>
            </StyledSubNestedList>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              e. You will not store, make available or transmit in or through the Solution any material which:
            </Typography>

            <StyledSubNestedList>
              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (i) infringes any person&apos;s intellectual property rights:
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (ii) is or is likely to be perceived as defamatory, threatening, misleading, offensive or inappropriate, or materially misrepresents facts; 
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (iii) adversely affects performance or availability of the Solution (or any part thereof);
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (iv) contains any virus, harmful component or corrupted data;
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (v) contains any advertising, promotion or solicitation; or
                </Typography>
              </ListItem>

              <ListItem sx={{ display: 'block', paddingTop: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    '&.MuiTypography-root': {
                      fontSize: '14px',
                    },
                  }}
                >
                  (vi) violates any applicable law or regulation.
                </Typography>
              </ListItem>
            </StyledSubNestedList>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              f. In the event that PwC becomes aware of any breach or alleged breach of this clause 1, PwC may suspend or terminate service for part or all of the Solution to which the allegations relate.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              g. You understand that PwC cannot and will not undertake to review or approve any material uploaded, posted or published on the Solution by you or by other users of the Solution.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              h. You are encouraged to use all reasonable endeavours to keep any submitted documents complete and up to date.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              i. PwC further reserves the right to deny you access to the Solution in the event PwC reasonably believes that you may have violated the provisions of this Section 1 or are otherwise in breach of this Agreement or the Engagement Letter and its Addendum.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              j. In addition, PwC may, without notice, suspend access to the Solution to you under this Agreement, destroy any information or data entered by you on the Solution, to the extent that PwC is required by law or order of any court or regulator to do so. 
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              k. PwC reserves the right to change without notice, at its sole discretion, the performance, functionality and availability of the Solution. 
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              l. All right, title and interest in and to the Solution &amp; any modifications or enhancements or derivative works created out of them, or any upgrades/updates/fixes etc, including without limitation all information and related technology, shall remain the sole and exclusive ownership of PwC or relevant PwC Entity and/or its/their licensors and, other than set out in this Agreement, you shall have no rights, title or interest in the Solution or any of PwC&apos;s other intellectual property. You acknowledge such ownership and intellectual property rights and you will not take any action to jeopardise, limit or interfere in any manner with PwC&apos;s or its licensors&apos; ownership of or rights with respect to the same.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              m. The Solution, and the associated services, are intended solely for use in India, as specified in the Engagement Letter. We make no representation that the Solution is available or otherwise suitable for use outside of India. Notwithstanding the above, if you access or use the Solution outside India, you do so on your own initiative and are responsible for the consequences and for compliance with all applicable laws including export control laws.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              n. The Solution is intended to be used to assist your employer only, and, as such, should not be considered as a substitute for maintain records by yourselves, and is not intended for assisting any other compliances including any legal, taxation or regulatory compliances.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block', paddingTop: 1 }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              o. We may monitor use of the Solution from time to time but have no obligation to do so.
            </Typography>
          </ListItem>
        </StyledNestedList>
      </ListItem>

      {/* Section 2: Linking */}
      <ListItem
        alignItems="flex-start"
        sx={{
          display: 'block',
        }}
      >
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            '&.MuiTypography-root': {
              fontSize: '14px',
            },
          }}
        >
          2. Linking
        </Typography>

        <StyledNestedList>
          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              a. You may not link or integrate to the Solution with any website or software or tools or platform without PwC&apos;s prior written consent.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              b. If and where the Solution provides any links to any third party website, such website may not be under PwC&apos;s (or a PwC Entity&apos;s) control and accordingly PwC and PwC Entities will have no responsibility for, and do not make any representations or warranties with respect to, such website or any content, products or services connected with such website, and PwC and PwC Entities do not endorse any of the same.
            </Typography>
          </ListItem>
        </StyledNestedList>
      </ListItem>

      {/* Section 3: Liability */}
      <ListItem
        alignItems="flex-start"
        sx={{
          display: 'block',
        }}
      >
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            '&.MuiTypography-root': {
              fontSize: '14px',
            },
          }}
        >
          3. Liability
        </Typography>

        <StyledNestedList>
          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              a. Unless expressly stated otherwise, the Solution is for monitoring purposes only and does not itself constitute the provision of any specific legal advice nor any other professional services or advice of any kind.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              b. You agree that you will be liable to PwC, each PwC Entity and its or their licensors, contractors and insurers and You agree to indemnify PwC, each PwC Entity from any and all losses, damages, liabilities, costs (including reasonable attorneys&apos; fees) and expenses in connection with any claim arising out of or in connection with any content or information posted or transmitted by you using the Solution or that otherwise arise out of your use of the Solution or that of any other third party (even if permitted by PwC) who is given or gains access to the Solution due to your action or inaction.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              c. You agree that neither PwC, any PwC Entity nor any of its or their contractors will be liable for any (i) work stoppage including inability to access the Solution, (ii) loss, corruption or unavailability of information and/or data, security breaches, viruses, computer failure or malfunction, use, data loss or other intangible losses or commercial damages due to the Solution, (iii) loss of profit, goodwill, business opportunity, anticipated savings or benefits, or (iv) indirect, consequential, special, incidental or exemplary damages or loss of any kind arising out of or related to this Agreement or your use of the Solution, even if advised of the possibility of such loss.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                  textTransform: 'uppercase',
                },
              }}
            >
              d. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, PWC &amp; PWC ENTITY SHALL NOT BE RESPONSIBLE OR LIABLE TO YOU OR ANY OTHER PERSON OR ENTITY FOR ANY ERRORS OR OMISSIONS IN THE SOLUTION; ANY INFORMATION MADE AVAILABLE THROUGH IT; ANY DECISION MADE OR ACTION TAKEN IN RELIANCE ON THE SOLUTION OR THE INFORMATION MADE AVAILABLE THROUGH IT; OR FOR ANY LOSS OR DAMAGES - INCLUDING CONSEQUENTIAL, SPECIAL OR SIMILAR DAMAGES - THAT ARISE OUT OF OR IN CONNECTION WITH YOUR USE OF THE SOLUTION OR ANY INFORMATION OR MATERIALS OBTAINED BY YOU VIA OR IN CONNECTION WITH THE SOLUTION.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              e. You agree that you will not bring any claim (whether in contract, tort (including negligence) or otherwise) against any PwC Entity (or its/ PwC&apos;s partners, members, directors or employees) or PwC&apos;s / PwC Entity&apos;s contractors in respect of the Solution or this Agreement.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              f. The Solution and all information provided to you via the Solution is provided &quot;as is&quot; and &quot;as available.&quot; To the maximum extent permitted by applicable law, PwC disclaim all express, implied, and statutory warranties with respect to the same, including without limitation any implied warranties of merchantability, fitness for a particular purpose, accuracy, completeness, non-infringement, non-interference, error-free service, and uninterrupted service.
            </Typography>
          </ListItem>
        </StyledNestedList>
      </ListItem>

      {/* Section 4: Downtime, Data Loss and Security */}
      <ListItem alignItems="flex-start" sx={{ display: 'block' }}>
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            '&.MuiTypography-root': {
              fontSize: '14px',
            },
          }}
        >
          4. Downtime, Data Loss and Security
        </Typography>

        <StyledNestedList>
          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              a. You understand and agree that no representation or warranty is made with respect to the functionality or availability of the Solution, and that all or any portion(s) of the Solution may for a variety of reasons be unavailable to you for use either temporarily or permanently without notice.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              b. You further agree and understand that information and data related to the Solution may be irretrievably lost or destroyed at any time, and it will be your responsibility to make all necessary copies and backups of any appropriate information and data posted to or obtained or available from the Solution.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              c. You understand and agree that the Solution may be unavailable due to scheduled or emergency maintenance.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              d. PwC reserves the right to prevent or limit access to the Solution for security, upgrades or other reasonable purposes.
            </Typography>
          </ListItem>
        </StyledNestedList>
      </ListItem>

      {/* Section 5: Confidentiality */}
      <ListItem
        alignItems="flex-start"
        sx={{ display: 'block', paddingTop: 2 }}
      >
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            '&.MuiTypography-root': {
              fontSize: '14px',
            },
          }}
        >
          5. Confidentiality
        </Typography>

        <Typography
          variant="body2"
          sx={{
            paddingTop: 1,
            '&.MuiTypography-root': {
              fontSize: '10pt',
            },
          }}
        >
          You agree to use any confidential information in the Solution only for the purposes for which it was provided, and not to disclose it, except where required by law or regulation. PwC may, in relation to the agreed purposes, provide confidential information to PwC Entities or relevant contractors.
        </Typography>
      </ListItem>

      {/* Section 6: Data Protection */}
      <ListItem alignItems="flex-start" sx={{ display: 'block' }}>
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            '&.MuiTypography-root': {
              fontSize: '14px',
            },
          }}
        >
          6. Data Protection
        </Typography>

        <StyledNestedList>
          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              a. To the extent that any material you upload, or post, on the Solution, or provide to us in connection with your access to the Solution, contains any personal data, you confirm that you have the authority and applicable consents to disclose such personal data, in accordance with applicable data privacy laws, to PwC, PwC Entities and its/their contractors and to allow PwC, PwC Entities and its/their contractors whether in India or outside India to process it for the purposes for which it was provided. In this regard, you confirm that you have read, understood and agree to the Privacy Statement as applicable to your access of the Solution (deeplink – link within the Terms of Use). You confirm that processing such data in accordance with these Terms and the Privacy Statement will not place us in breach of relevant data privacy laws.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              b. If PwC processes as a data processor on your behalf any of your personal data, PwC shall only process such personal data on your lawful instructions; you confirm that processing such data in accordance with the terms of this Agreement will not place PwC in breach of relevant data privacy laws. PwC shall take appropriate technical and organizational security measures over such personal data.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              c. PwC has implemented appropriate technical, organizational and security measures, in line with the industry standard security best practices to protect against unauthorized access to or unauthorized alteration, disclosure, destruction or loss of personal data.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              d. You acknowledge and agree that the confidentiality aspects pertaining to your access and usage of the Solution, including any personal data transmitted to us by you in connection thereto, is governed by the confidentiality and data protection clauses, as signed between PwC and the entity that you represent or act on behalf of, in the underlying Agreement between PwC and such entity relating to your access and usage. PwC protects this information by maintaining physical, electronic and procedural safeguards that meet applicable Indian laws and regulations. You also acknowledge that there may be third party sites, through which the Solution is made accessible to you or otherwise hosted, that do not operate under PwC&apos;s privacy practices/procedures. Where you visit such sites, PwC&apos;s privacy practices/procedures no longer apply. You should review each such sites&apos; privacy policy or statements before disclosing any personal data. In connection with your access to the Solution you may need to link to, transmit your content to, or otherwise access third parties&apos; websites, platforms, content, products, services and information. PwC does not control and is not responsible for such third parties&apos; websites, platforms, content, products, services and information.
            </Typography>
          </ListItem>
        </StyledNestedList>
      </ListItem>

      {/* Section 7: Term and Termination */}
      <ListItem alignItems="flex-start" sx={{ display: 'block' }}>
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            '&.MuiTypography-root': {
              fontSize: '14px',
            },
          }}
        >
          7. Term and Termination
        </Typography>

        <StyledNestedList>
          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              a. PwC may terminate this Agreement, with or without cause, at any time, by sending an email to your email address specified in your user profile.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              b. If you are no longer associated with any project(s) in the Solution (for reasons such as you having moved to some other assignment or having left the entity on whose behalf you are entering into this Agreement), you agree to inform the Portal Administrator of the Solution at least five days before the date of your disassociation with such project(s). You agree that you shall not access the Solution for any such project(s) from which you are disassociated.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              c. The Solution is provided only for the purposes as originally intended by the parties unless otherwise agreed in writing, and the Solution is not intended as a permanent repository for any of the documents or materials uploaded onto it by or on behalf of the parties. On termination or expiry of this Agreement (or, if earlier, on expiry or termination of the engagement contract with PwC to which the Solution relates or the purposes for which the Solution was provided), access to the Solution may be terminated, and the Solution may be closed and any documents or materials on the Solution may be deleted. Prior to such event and subject to any confidentiality requirements and applicable terms in any such engagement contract, each party is responsible for retrieving and storing elsewhere any documents and materials which it has uploaded onto the Solution.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              d. All terms and condition of this Agreement that are intended by their nature to survive termination of this Agreement shall survive termination and remain in full force, including but not limited to the terms and conditions concerning any disclaimers, intellectual property rights, duties of confidentiality, limitations of liability, indemnities and provisions regarding resolution of differences. Although each party&apos;s further rights and obligations cease immediately on termination of this agreement, termination does not affect a party&apos;s accrued rights and obligations at the date of termination. 
            </Typography>
          </ListItem>
        </StyledNestedList>
      </ListItem>

      {/* Section 8: General */}
      <ListItem
        alignItems="flex-start"
        sx={{ display: 'block', paddingTop: 2 }}
      >
        <Typography
          component="span"
          sx={{
            fontWeight: 'bold',
            '&.MuiTypography-root': {
              fontSize: '14px',
            },
          }}
        >
          8. General
        </Typography>

        <StyledNestedList>
          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              a. Portions of this program may use the following Open-Source Software (&quot;OSS&quot;):
            </Typography>

            <Box sx={{ mt: 2 }}>
              <CommonTable
                columns={columns}
                data={tableData}
                loading={false}
                showActions={false}
              />
            </Box>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              b. The source code of each of the OSS along with their Open-Source License Terms (each an &quot;OSS License&quot;) can be obtained from their respective links above. In the event of a conflict between the terms of any OSS License, or any additional terms (such as, for example, disclaimers) imposed thereby, and those of any license or other terms provided by PricewaterhouseCoopers Private Limited with the Solution (&quot;Terms&quot;), those of the OSS License shall prevail. Without limiting the foregoing, to the extent any such OSS License prohibits restrictions contained in the Terms with respect to an OSS, such restrictions will not apply to such OSS. Notwithstanding anything to the contrary set forth in the Terms, we will have no liability with respect to claims of infringement or misappropriation of third-party intellectual property rights arising from such OSS. Any OSS is provided on an &quot;as is&quot; basis, without warranty of any kind, either expressed, implied, or statutory, including, without limitation, any warranty of the same being free from defects, merchantable, fit for a particular purpose or non-infringing. The entire risk as to the quality and performance of any OSS is with you. Should any OSS prove defective in any respect, you alone assume the cost of any necessary servicing, repair, or correction. This disclaimer of warranty constitutes an essential part of the OSS Licenses and Terms. No use of any OSS is authorized under the OSS Licenses or Terms except under this disclaimer. Any Terms that differ from the terms of the OSS Licenses, including any additional warranties or service level, maintenance or other obligations that may be offered by us, are offered by us alone. Under no circumstances and under no legal theory, whether tort (including negligence), contract, or otherwise, shall any contributor to the OSS, or anyone who distributes the OSS as permitted by the OSS Licenses, be liable to you for any direct, indirect, special, incidental, or consequential damages of any character including, without limitation, damages for lost profits, loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses, even if you have been informed of the possibility of such damages. This limitation of liability shall not apply to liability for death or personal injury resulting from negligence to the extent applicable law prohibits such limitation. Some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, in which event this exclusion and limitation may not apply to you.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              c. These terms and conditions will apply on each occasion you access the Solution, however PwC may amend this Agreement at any time. Upon posting on the Solution, the new terms are automatically effective and binding on you. If you do not wish to accept such amendment you may stop using the Solution and delete it from your device. All subsequent access and use of the Solution will be subject to such amended terms of use. This Agreement may not be otherwise amended.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              d. In the event of any conflict between this Agreement and any procedures or requirements set out in the Solution, the provisions of this Agreement will prevail.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              e. In the event of any conflict between this Agreement and the terms of any engagement contract between you and PwC for the agreed purposes to which the Solution relates, the terms of such engagement contract will prevail.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              f. If any provision of this Agreement is held to be invalid, void or illegal, it will be severed from this Agreement and will not affect, impair or invalidate any other provision, and it will be replaced by a provision which comes closest to such severed provision in language and intent without being invalid, void or illegal.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              g. You may not assign, transfer or deal with their rights or obligations under this Agreement.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              h. No right under this Agreement or breach hereof may be waived by us except in writing signed by us. Our failure to require performance of any provision of this Agreement will not be construed as a waiver of our rights to insist on performance of such provision or any other provision at some other time.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              i. Each PwC Entity may enforce the provisions of clauses 1, 2 and 3 as applicable, as third party beneficiaries to this Agreement.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              j. If a dispute arises, the parties will attempt to resolve it by discussion, negotiation and mediation before commencing legal proceedings.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              k. This Agreement and any dispute arising from it between PwC and you, whether contractual or non-contractual, will be governed by the laws of India. Subject to the terms of the Agreement, such dispute shall be referred to arbitration in India in accordance with the provisions of the Arbitration and Conciliation Act, 1996. The authority of the arbitrator(s) shall be subject to the terms of this Agreement, including liability limitation. Subject to the foregoing provisions on arbitration, this Agreement and any dispute arising from it, whether contractual or non-contractual, will be subject to the exclusive jurisdiction of the competent courts of India.
            </Typography>
          </ListItem>

          <ListItem sx={{ display: 'block' }}>
            <Typography
              variant="body2"
              sx={{
                '&.MuiTypography-root': {
                  fontSize: '10pt',
                },
              }}
            >
              l. Depending on the version of the Solution you have access to, you agree to comply with any applicable additional terms and conditions as may be prescribed, including any privacy statements (&quot;Additional Terms&quot;). If there is any conflict between these Terms and the Additional Terms, then these Terms will prevail.
            </Typography>
          </ListItem>
        </StyledNestedList>
      </ListItem>

      <Typography variant="h6" sx={{ font: '700', color: '#000', fontWeight: 'medium' }}>
        BY CLICKING THE LINK YOU CERTIFY THAT YOU HAVE READ AND UNDERSTOOD THIS AGREEMENT, AND AGREE TO BE BOUND BY ITS PROVISIONS.
      </Typography>
        
    </Box>
  )
}
